/**
 * @module events/types/keyDown
 */

/**
 * @type {string}
 */
export default 'keydown'
